import { useEffect, useState } from 'react';

/** Breakpoint alinhado ao CSS `@media (max-width: 991px)` do shell Nexus. */
export const NX_MOBILE_MQ = '(max-width: 991px)';

/** Tablet Compra Fiscal — tabela compacta sem wide min-width. */
export const NX_TABLET_MQ = '(min-width: 992px) and (max-width: 1199px)';

/** Desktop amplo — wide mode da tabela de revisão. */
export const NX_DESKTOP_WIDE_MQ = '(min-width: 1200px)';

export function useMediaQuery(query: string): boolean {
    const [matches, setMatches] = useState(() => {
        if (typeof window === 'undefined') {
            return false;
        }
        return window.matchMedia(query).matches;
    });

    useEffect(() => {
        const mql = window.matchMedia(query);
        const onChange = () => setMatches(mql.matches);
        onChange();
        mql.addEventListener('change', onChange);
        return () => mql.removeEventListener('change', onChange);
    }, [query]);

    return matches;
}

export function useIsMobileShell(): boolean {
    return useMediaQuery(NX_MOBILE_MQ);
}

export function useIsCompraFiscalTabletViewport(): boolean {
    return useMediaQuery(NX_TABLET_MQ);
}

export function useIsDesktopWideViewport(): boolean {
    return useMediaQuery(NX_DESKTOP_WIDE_MQ);
}
